import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import Header from "../components/header";
import Main from "../components/main";
import ApiService from "../api/apiService";
import Websocket from "../hooks/ws";
import { WebSocketContext, ChatContext } from "../context/contexts";
import showSwal from "../components/swal";
import { common } from "../util/common";
import notifSound from "../sounds/notif-sound.mp3";
import { isMobile } from "react-device-detect";
import Loader from "../components/reusable/loader";

function ChatIndex(props) {
  const { userDetails, linkConversation } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [viewChangePasswordModal, setViewChangePasswordModal] = useState(false);

  const [attachedListener, setAttachedListener] = useState(false);

  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [storedConversationId, setConversationId] = useState(null);
  const [conversationData, setConversationData] = useState(null);
  const [conversationUserPermission, setConversationUserPermission] =
    useState(null);
  const [isPermittedToChat, setIsPermittedToChat] = useState(true);
  const [conversationMembersData, setConversationMembers] = useState([]);
  const [messagesData, setMessagesData] = useState(null);

  const [wsMessagesData, setWsMessagesData] = useState([]);

  const [wsDeleteActionsMessageId, setWsDeleteActionsMessageId] =
    useState(null);

  const [wsTheradMsgs, setWsThreadMsgs] = useState(null);

  const [wsReactionMessageId, setWsReactionMessageId] = useState(null);
  const [wsDeletedReactionMessageId, setWsDeletedReactionMessageId] =
    useState(null);
  const [wsReactionMessageDetail, setWsReactionMessageDetail] = useState(null);

  const [hasSelectedChat, setHasSelectedChat] = useState(false);
  const [isMobileMode, setMobileMode] = useState(false);
  const [isMobileChatDetailShow, setMobileChatDetailShow] = useState(false);
  const [chatReplyData, setChatReplyData] = useState(null);
  const messageMainRef = useRef(null);
  const isLoadingMoreRef = useRef(false);
  const isAtBottomRef = useRef(true);
  const activeConversationIdRef = useRef(null);

  const [threadViewMsgId, setThreadViewMsgId] = useState(null);
  const [threadViewVisible, setThreadViewVisible] = useState(false);
  const [reactionsViewVisible, setReactionsViewVisible] = useState(false);
  const [reactionViewList, setReactionViewList] = useState([]);
  const [threadViewDetails, setThreadViewDetails] = useState(null);
  const [storedThreadMessageId, setStoredThreadMessageId] = useState(null);

  const [onlineUsers, setOnlineUsers] = useState([]);

  const [isShowingTyping, setShowingTyping] = useState(false);
  const [typingData, setTypingData] = useState(null);

  const [seenMessageData, setSeenMessageData] = useState(null);

  const [pinMessageData, setPinMessageData] = useState(null);

  const [conversationLimit, setConversationLimit] = useState(9);
  const websocketInstance = useRef(new Websocket()).current;
  const conversationCacheRef = useRef(new Map());
  const CONVERSATION_CACHE_TTL_MS = 60 * 1000;
  const [wsConnectionState, setWsConnectionState] = useState(
    websocketInstance.getConnectionState?.() || {
      status: "disconnected",
      attempt: 0,
      reason: null,
      roomId: null,
    },
  );
  const [isRealtimeSyncing, setIsRealtimeSyncing] = useState(false);
  const previousWsStatusRef = useRef(wsConnectionState.status);

  const hasValidLinkConversation =
    linkConversation !== null &&
    linkConversation !== undefined &&
    String(linkConversation).trim() !== "";

  useEffect(() => {
    if (userDetails.id && userDetails.display_name) {
      setLoggedIn(true);
      websocketInstance.initConnection(
        userDetails.id,
        userDetails.display_name,
      );
      websocketInstance.indicateOnline(
        userDetails.id,
        userDetails.display_name,
        (callback) => {
          setOnlineUsers(callback);
        },
      );
    } else {
      setLoggedIn(false);
    }
  }, [userDetails]);

  useEffect(() => {
    let countdownTimer;
    let countdownCompleted = false;

    if (isMobile) {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          if (websocketInstance.socket && !websocketInstance.socket.connected) {
            websocketInstance.socket.connect();
          }
        }
      };
      const startCountdown = () => {
        countdownTimer = setTimeout(() => {
          countdownCompleted = true;
        }, 25000);
      };

      const clearCountdown = () => {
        clearTimeout(countdownTimer);
        countdownCompleted = false;
      };

      const visibleListener = () => {
        if (countdownCompleted) {
          window.location.reload();
        } else {
          clearCountdown();
        }
      };

      const invisibleListener = () => {
        startCountdown();
      };

      window.addEventListener("focus", visibleListener);
      window.addEventListener("blur", invisibleListener);

      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange,
        );
        window.removeEventListener("focus", visibleListener);
        window.removeEventListener("blur", invisibleListener);
        clearCountdown();
      };
    }
  }, []);

  const [conversationFlag, setConversationFlag] = useState("personal");
  useEffect(() => {
    if (isLoggedIn) {
      const fetchConversationData = async () => {
        try {

          const result =
            await ApiService.v3.conversations.getConversationByUserWithFlag(
              conversationFlag,
              1,
              conversationLimit,
            );

          setData(result);
        } catch (error) {
          console.log(error);
          // setError(error);
        }
      };

      fetchConversationData();
      // const intervalId = setInterval(fetchConversationData, 2500);
      const intervalId = setInterval(fetchConversationData, 45 * 1000); // 45 seconds
      return () => clearInterval(intervalId);
    }
  }, [isLoggedIn, conversationFlag, conversationLimit]);

  const handleWSMsgs = (wsMsg) => {
    const __notif = new Audio(notifSound);
    if (
      wsMsg.type === "user-chat" ||
      wsMsg.type === "user-actions-chat" ||
      wsMsg.type === "user-thread-chat"
    ) {
      if (wsMsg.type === "user-thread-chat") {
        handleThreadChat(wsMsg.message);
      } else {
        const activeConversationId = activeConversationIdRef.current;
        if (wsMsg.message.conversation_id !== activeConversationId) {
          return;
        }

        setWsMessagesData((prevState) => [...prevState, wsMsg.message]);
        websocketInstance.seenMessage(
          userDetails.id,
          userDetails.display_name,
          wsMsg.message.conversation_id,
          wsMsg.message.id,
        );
        if (userDetails.id !== wsMsg.message.sender_id) {
          // __notif.play().catch((err) => {});
        }

        if (wsMsg.message.action !== "DELETE") {
          if (isAtBottomRef.current) {
            setTimeout(() => scrollToBottom(), 100);
          }
        } else {
          handleMsgDeleted(wsMsg.message.chat_id);
        }
      }
    } else if (wsMsg.type === "user-reactions-chat") {
      const reactionType = wsMsg?.message?.type;
      if (reactionType === "created") {
        setWsReactionMessageId(wsMsg.message.id);
      } else {
        setWsDeletedReactionMessageId(wsMsg.message.id);
      }
      setWsReactionMessageDetail(wsMsg.message);
    }
  };

  const handleMsgDeleted = (chat_id) => {
    setWsDeleteActionsMessageId(chat_id);
  };

  const handleThreadChat = (chat_thread_detail) => {
    setWsThreadMsgs(chat_thread_detail);
  };

  const handleReceiveSeenMesasge = (data) => {
    setSeenMessageData(data);
  };

  const handleReceivePinMessage = (data) => {
    setPinMessageData(data);
  };

  const handleWSSidebarMsgs = async () => {
    try {
      const result = await ApiService.conversation.getAllConversations();
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  const typingTimeoutRef = useRef(null); // Use ref to hold the timeout

  const setIsAtBottom = useCallback((val) => {
    isAtBottomRef.current = val;
  }, []);

  const applyMessagePatch = useCallback((messageId, patchFn) => {
    setMessagesData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        messages: prev.messages.map((msg) =>
          msg.id === messageId ? patchFn(msg) : msg
        ),
      };
    });
    setWsMessagesData((prev) =>
      prev.map((msg) => (msg.id === messageId ? patchFn(msg) : msg))
    );
  }, []);

  const connectWSRoom = (conversation_id) => {
    websocketInstance.connectRoom(conversation_id);
    if (!attachedListener) {
      websocketInstance.setupListeners((data) => {
        handleWSMsgs(data);
      });
      websocketInstance.seenMessage(
        userDetails.id,
        userDetails.display_name,
        conversation_id,
      );
      websocketInstance.receiveSeenMessage((data) => {
        handleReceiveSeenMesasge(data);
      });
      websocketInstance.receivePinMessage((data) => {
        handleReceivePinMessage(data);
      });
      websocketInstance.setupDisconnectListener();
      setAttachedListener(true);

      websocketInstance.currentlyTypingListener((typingData) => {
        if (typingData) {
          setShowingTyping(true);
          setTypingData(typingData);

          clearTimeout(typingTimeoutRef.current);

          typingTimeoutRef.current = setTimeout(() => {
            setShowingTyping(false);
            setTypingData(null);
          }, 1000);
        } else {
          setShowingTyping(false);
          setTypingData(null);
        }
      });
    }
  };

  useEffect(() => {
    if (!isLoggedIn || !hasValidLinkConversation) {
      return;
    }

    connectWSRoom(linkConversation);
  }, [isLoggedIn, hasValidLinkConversation, linkConversation]);

  useEffect(() => {
    websocketInstance.setConnectionStateListener(setWsConnectionState);

    return () => {
      websocketInstance.setConnectionStateListener(null);
    };
  }, [websocketInstance]);

  const syncMessagesAfterReconnect = useCallback(async () => {
    if (!storedConversationId) return;

    try {
      setIsRealtimeSyncing(true);
      const result = await ApiService.message.getConversationMessages(
        storedConversationId,
        null,
        30,
      );
      const { success, messages = [] } = result || {};

      if (!success || messages.length === 0) {
        return;
      }

      setMessagesData((prevState) => {
        if (!prevState) return prevState;

        const mergedMessagesMap = new Map();

        for (const message of prevState.messages || []) {
          mergedMessagesMap.set(message.id, message);
        }

        for (const message of messages) {
          mergedMessagesMap.set(message.id, message);
        }

        const mergedMessages = Array.from(mergedMessagesMap.values()).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );

        return {
          ...prevState,
          messages: mergedMessages,
        };
      });
    } catch (error) {
      console.error("Failed to sync messages after reconnect:", error);
    } finally {
      setIsRealtimeSyncing(false);
    }
  }, [storedConversationId]);

  useEffect(() => {
    const previousStatus = previousWsStatusRef.current;
    const currentStatus = wsConnectionState?.status;

    if (
      currentStatus === "connected" &&
      ["reconnecting", "disconnected", "failed"].includes(previousStatus)
    ) {
      syncMessagesAfterReconnect();
    }

    previousWsStatusRef.current = currentStatus;
  }, [wsConnectionState?.status, syncMessagesAfterReconnect]);

  useEffect(() => {
    const handleOnline = () => {
      const socket = websocketInstance.getConnection();
      if (socket && !socket.connected) {
        socket.connect();
      }
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, [websocketInstance]);

  const handleSetConversationData = (conversationDetail) => {
    const userDetails = localStorage.getItem("userDetails");
    const _userDetails = JSON.parse(userDetails);
    setConversationData(conversationDetail);
    const userPermissions = conversationDetail?.conversation.members.find(
      (conversationMember) => conversationMember.user_id === _userDetails.id,
    );
    setConversationUserPermission(userPermissions);
    setIsPermittedToChat(!userPermissions.is_muted);
    localStorage.setItem(
      "selectedConversationId",
      conversationDetail.conversation.id,
    );
  };

  const scrollToBottom = () => {
    const messageMain = messageMainRef.current;
    if (messageMain) {
      messageMain.scrollTo({
        top: messageMain.scrollHeight - messageMain.clientHeight,
        behavior: "auto",
      });
    }
  };

  const getCachedConversationPayload = useCallback((conversationId) => {
    const cachedPayload = conversationCacheRef.current.get(conversationId);

    if (!cachedPayload) return null;

    const isStale = Date.now() - cachedPayload.fetchedAt > CONVERSATION_CACHE_TTL_MS;
    if (isStale) {
      conversationCacheRef.current.delete(conversationId);
      return null;
    }

    return cachedPayload;
  }, []);

  const cacheConversationPayload = useCallback(
    (conversationId, conversationDetail, messagesDetail) => {
      conversationCacheRef.current.set(conversationId, {
        conversationDetail,
        messagesDetail,
        fetchedAt: Date.now(),
      });
    },
    [],
  );

  const applyConversationPayload = useCallback(
    (
      conversationId,
      conversationDetail,
      messagesDetail,
      messageLimit = 30,
    ) => {
      setConversationId(conversationId);
      handleSetConversationData(conversationDetail);
      setConversationMembers(conversationDetail.conversation.members);
      setMessagesData(messagesDetail);
      setHasMoreMessages((messagesDetail.messages?.length ?? 0) >= messageLimit);
      setHasSelectedChat(true);
      setChatReplyData(null);
      setWsMessagesData([]);

      if (isMobileMode) {
        setMobileChatDetailShow(true);
      } else {
        setMobileChatDetailShow(false);
      }
    },
    [isMobileMode],
  );

  const setConversationDetail = async (conversationId) => {
    activeConversationIdRef.current = conversationId;
    setConversationId(conversationId);
    setWsMessagesData([]);

    const cachedPayload = getCachedConversationPayload(conversationId);
    const hasCachedPayload = Boolean(cachedPayload);

    if (!hasCachedPayload) {
      setMessagesData(null);
      setConversationData(null);
      setLoading(true);
    } else {
      applyConversationPayload(
        conversationId,
        cachedPayload.conversationDetail,
        cachedPayload.messagesDetail,
      );
      setLoading(false);
    }

    try {
      const [conversationDetail, messagesDetail] = await Promise.all([
        ApiService.v2.conversations.getConversationDetailById(conversationId),
        ApiService.message.getConversationMessages(conversationId, null, 30),
      ]);

      if (activeConversationIdRef.current !== conversationId) return;

      const { success: conversationSuccess } = conversationDetail;
      const { success: messagesSuccess } = messagesDetail;

      if (!conversationSuccess || !messagesSuccess) {
        if (!hasCachedPayload) {
          setLoading(false);
          showSwal(common.errors.SET_CONVERSATION_DATA_ERROR).then(() => {
            window.location.reload();
          });
        }
        return;
      }

      cacheConversationPayload(conversationId, conversationDetail, messagesDetail);
      applyConversationPayload(conversationId, conversationDetail, messagesDetail);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => scrollToBottom());
      });
    } catch (error) {
      if (activeConversationIdRef.current !== conversationId) return;
      if (!hasCachedPayload) {
        setError(error);
      }
    } finally {
      if (activeConversationIdRef.current === conversationId) {
        if (!hasCachedPayload) {
          setTimeout(() => setLoading(false), 800);
        }
      }
    }
  };

  const reSetConversationDetail = async (
    conversationId,
    limit,
    callback,
  ) => {
    activeConversationIdRef.current = conversationId;
    setConversationId(conversationId);
    setWsMessagesData([]);
    setMessagesData(null);
    setConversationData(null);
    setLoading(true);
    try {
      const conversationDetail =
        await ApiService.v2.conversations.getConversationDetailById(
          conversationId,
        );
      const messagesDetail = await ApiService.message.getConversationMessages(
        conversationId,
        null,
        limit,
      );

      if (activeConversationIdRef.current !== conversationId) return;

      const { success: conversationSuccess } = conversationDetail;
      const { success: messagesSuccess } = messagesDetail;

      if (!conversationSuccess || !messagesSuccess) {
        setLoading(false);
        showSwal(common.errors.SET_CONVERSATION_DATA_ERROR).then(() => {
          window.location.reload();
        });
        return;
      }
      cacheConversationPayload(conversationId, conversationDetail, messagesDetail);
      applyConversationPayload(
        conversationId,
        conversationDetail,
        messagesDetail,
        limit,
      );
      setLoading(false);
      callback(true);
    } catch (error) {
      setLoading(false);
      if (activeConversationIdRef.current !== conversationId) return;
      console.error(error);
      setError(error);
    }
  };

  const updateConversationData = async (
    conversationId,
    isViewMoreClicked,
    oldScrollHeight,
  ) => {
    if (isViewMoreClicked && isLoadingMoreRef.current) return Promise.resolve();
    if (isViewMoreClicked) isLoadingMoreRef.current = true;

    try {
      setLoading(true);
      let conversationDetail, messagesDetail;
      if (isViewMoreClicked) {
        return new Promise((resolve) => {
          const messageMain = document.querySelector(".message__main");
          const savedScrollHeight = messageMain.scrollHeight;
          const savedScrollTop = messageMain.scrollTop;

          // Use the ID of the oldest currently loaded message as the cursor.
          // messagesData.messages is newest-first from the API, so the last
          // element is the oldest loaded message.
          const currentMessages = messagesData?.messages ?? [];
          const cursor = currentMessages[currentMessages.length - 1]?.createdAt ?? null;

          ApiService.message.getConversationMessages(
            storedConversationId,
            cursor,
            10,
          ).then((result) => {
            const incoming = result?.messages ?? [];

            // Append older messages after existing ones (both arrays are newest-first,
            // so appending keeps the array newest-first overall).
            setMessagesData((prev) => ({
              ...prev,
              messages: [...(prev?.messages ?? []), ...incoming],
            }));
            setHasMoreMessages(incoming.length >= 10);

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                const newScrollHeight = messageMain.scrollHeight;
                messageMain.scrollTop = newScrollHeight - savedScrollHeight + savedScrollTop;
                setLoading(false);
                isLoadingMoreRef.current = false;
                resolve();
              });
            });
          });
        });
      } else {
        conversationDetail =
          await ApiService.v2.conversations.getConversationDetailById(
            conversationId,
          );
        messagesDetail = await ApiService.message.getConversationMessages(
          conversationId,
        );
        const { success: conversationSuccess } = conversationDetail;
        const { success: messagesSuccess } = messagesDetail;
        if (!conversationSuccess || !messagesSuccess) {
          setLoading(false);
          showSwal(common.errors.UPDATE_CONVERSATION_DATA_ERROR).then(() => {
            window.location.reload();
          });
        }
        setConversationId(conversationId);
        handleSetConversationData(conversationDetail);
        setConversationMembers(conversationDetail.conversation.members);
        setMessagesData(messagesDetail);
        setHasMoreMessages((messagesDetail.messages?.length ?? 0) >= 30);
        setHasSelectedChat(true);
        setChatReplyData(null);
        setWsMessagesData([]);
        isMobileMode
          ? setMobileChatDetailShow(true)
          : setMobileChatDetailShow(false);
        setLoading(false);
      }
    } catch (error) {
      isLoadingMoreRef.current = false;
      setError(error);
    }
  };

  const showHideChangePasswordModal = () => {
    setViewChangePasswordModal(!viewChangePasswordModal);
  };

  // WS mutation effects — apply incoming WS events to message state immutably.
  // These replace the direct context-object mutations that were previously in main.jsx.

  useEffect(() => {
    if (!wsDeleteActionsMessageId) return;
    applyMessagePatch(wsDeleteActionsMessageId, (msg) => ({ ...msg, is_deleted: true }));
  }, [wsDeleteActionsMessageId]);

  useEffect(() => {
    if (!wsTheradMsgs?.reply_to_thread_message_id) return;
    applyMessagePatch(wsTheradMsgs.reply_to_thread_message_id, (msg) => ({
      ...msg,
      thread_replies: [...(msg.thread_replies ?? []), wsTheradMsgs],
    }));
  }, [wsTheradMsgs]);

  useEffect(() => {
    if (!wsReactionMessageId || !wsReactionMessageDetail) return;
    applyMessagePatch(wsReactionMessageDetail.message_id, (msg) => ({
      ...msg,
      message_reactions: [...msg.message_reactions, wsReactionMessageDetail],
    }));
  }, [wsReactionMessageId]);

  useEffect(() => {
    if (!wsDeletedReactionMessageId || wsReactionMessageDetail?.type !== "removed") return;
    applyMessagePatch(wsReactionMessageDetail.message_id, (msg) => ({
      ...msg,
      message_reactions: msg.message_reactions.filter(
        (r) => r.id !== wsReactionMessageDetail.id
      ),
    }));
  }, [wsDeletedReactionMessageId]);

  useEffect(() => {
    if (!seenMessageData?.user_id) return;
    const { user_id, display_name, message_id } = seenMessageData;
    const applySeenPatch = (msg) => {
      const reads = (msg.message_reads ?? []).filter((r) => r?.user_id !== user_id);
      if (msg.id === message_id) {
        reads.push({
          id: "-WS",
          user: { id: user_id, display_name: display_name ?? "Unknown" },
          user_id,
        });
      }
      return { ...msg, message_reads: reads };
    };
    setMessagesData((prev) => {
      if (!prev) return prev;
      return { ...prev, messages: prev.messages.map(applySeenPatch) };
    });
    setWsMessagesData((prev) => prev.map(applySeenPatch));
  }, [seenMessageData]);

  useEffect(() => {
    if (!pinMessageData) return;
    setConversationData((prev) => {
      if (!prev?.conversation) return prev;
      return {
        ...prev,
        conversation: {
          ...prev.conversation,
          pinned_message: pinMessageData.pin_data ?? null,
        },
      };
    });
    if (!pinMessageData.pin_data?.id) return;
    const pinId = pinMessageData.pin_data.id;
    const pinValue = pinMessageData.pin_data.is_pinned;
    const applyPinPatch = (msg) => ({
      ...msg,
      is_pinned: msg.id === pinId ? pinValue : false,
    });
    setMessagesData((prev) => {
      if (!prev) return prev;
      return { ...prev, messages: prev.messages.map(applyPinPatch) };
    });
    setWsMessagesData((prev) => prev.map(applyPinPatch));
  }, [pinMessageData]);

  const handleThreadViewMsgId = (id, conversation_id = null) => {
    setThreadViewMsgId(id);
    fetchThreadDetails(id, conversation_id);
  };

  const handleThreadViewVisible = () => {
    setThreadViewVisible(!threadViewVisible);
  };
  const handleReactionsViewVisible = (reactions = []) => {
    setReactionViewList(reactions);
    setReactionsViewVisible(!reactionsViewVisible);
  };

  const fetchThreadDetails = async (message_id, conversation_id = null) => {
    setLoading(true);
    const finalConversationId = conversation_id
      ? conversation_id
      : storedConversationId;
    const threadDetails = await ApiService.message.getThreadMessages(
      finalConversationId,
      message_id,
    );
    const { success, thread_detail } = threadDetails;
    if (!success) {
      setLoading(false);
      showSwal(common.errors.FETCH_THREAD_ERROR);
    }
    setThreadViewDetails(thread_detail);
    setStoredThreadMessageId(message_id);
    handleThreadViewVisible(true);
    setLoading(false);
  };
  const reFetchThreadDetails = async (message_id) => {
    const threadDetails = await ApiService.message.getThreadMessages(
      storedConversationId,
      message_id,
    );
    const { success, thread_detail } = threadDetails;
    if (!success) {
      showSwal(common.errors.FETCH_THREAD_ERROR);
    }
    setThreadViewDetails(thread_detail);
    setLoading(false);
  };

  useEffect(() => {
    if (isLoggedIn && storedThreadMessageId && threadViewVisible) {
      // const intervalId = setInterval(() => reFetchThreadDetails(storedThreadMessageId), 5000);
      const intervalId = setInterval(
        () => reFetchThreadDetails(storedThreadMessageId),
        45 * 1000,
      );
      return () => clearInterval(intervalId);
    }
  }, [isLoggedIn, storedThreadMessageId, threadViewVisible]);

  const chatContextValue = useMemo(() => ({
    setConversationDetail,
    storedConversationId,
    conversationData,
    conversationUserPermission,
    isPermittedToChat,
    conversationMembersData,
    messagesData,
    hasSelectedChat,
    setChatReplyData,
    chatReplyData,
    isMobileChatDetailShow,
    setMobileMode,
    messageMainRef,
    updateConversationData,
    hasMoreMessages,
    setMessagesData,
    setMobileChatDetailShow,
    isMobileMode,
    scrollToBottom,
    wsMessagesData,
    wsDeleteActionsMessageId,
    handleThreadViewMsgId,
    threadViewMsgId,
    handleThreadViewVisible,
    threadViewVisible,
    threadViewDetails,
    reFetchThreadDetails,
    wsTheradMsgs,
    reSetConversationDetail,
    wsReactionMessageId,
    wsReactionMessageDetail,
    wsDeletedReactionMessageId,
    setWsReactionMessageId,
    isLoggedIn,
    isLoading: loading,
    onlineUsers,
    isShowingTyping,
    typingData,
    seenMessageData,
    wsConnectionState,
    isRealtimeSyncing,
    setConversationFlag,
    pinMessageData,
    setConversationLimit,
    handleReactionsViewVisible,
    reactionsViewVisible,
    reactionViewList,
    setIsAtBottom,
  }), [
    storedConversationId, conversationData, conversationUserPermission,
    isPermittedToChat, conversationMembersData, messagesData, hasSelectedChat,
    chatReplyData, isMobileChatDetailShow, isMobileMode, hasMoreMessages,
    wsMessagesData, wsDeleteActionsMessageId, threadViewMsgId, threadViewVisible,
    threadViewDetails, wsTheradMsgs, wsReactionMessageId, wsReactionMessageDetail,
    wsDeletedReactionMessageId, isLoggedIn, loading, onlineUsers, isShowingTyping,
    typingData, seenMessageData, wsConnectionState, isRealtimeSyncing,
    pinMessageData, reactionsViewVisible, reactionViewList,
  ]);

  return (
    <>
      <WebSocketContext.Provider
        value={{
          websocketInstance: websocketInstance,
          connectWSRoom: connectWSRoom,
        }}
      >
        <ChatContext.Provider value={chatContextValue}>
          <Loader isLoading={loading} />
          {/* <Header
            userDetails={userDetails}
            showHideChangePasswordModal={showHideChangePasswordModal}
            viewChangePasswordModal={viewChangePasswordModal}
          /> */}
          <Main
            conversations={data?.conversations}
            conversationsCount={data?.pagination?.total}
            setConversationLimit={setConversationLimit}
            conversationLimit={conversationLimit}
            userDetails={userDetails}
            linkConversation={linkConversation}
            showHideChangePasswordModal={showHideChangePasswordModal}
            viewChangePasswordModal={viewChangePasswordModal}
          />
        </ChatContext.Provider>
      </WebSocketContext.Provider>
    </>
  );
}

export default ChatIndex;
